import { Pass } from 'data/Pass'
import PassItem from './PassItem/PassItem'
import React from 'react'
import UserSettingTab from 'components/common/UserSettingTab/UserSettingTab'
import { useStyles } from './styles'

interface PassesProps {
    passes: Pass[]
}

const PassList: React.FC<PassesProps> = ({ passes }) => {
    const classes = useStyles()
    return (
        <UserSettingTab title="Passes">
            {passes.map(pass => (
                <PassItem key={pass._id} pass={pass} />
            ))}

            {!passes.length && <p className={classes.noPasses}>You haven't purchased any passes yet</p>}
        </UserSettingTab>
    )
}

export default React.memo(PassList)
